import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ClaimContainer = styled(Container)`
    font-family: Montserrat, sans-serif;
    background-color: #bdd2e2; /* Light blue background */
    padding: 3rem 1.5rem;
    text-align: center;
    color: #333;
`;

const ClaimButton = styled.button`
    background-color: #1b1464; /* Dark blue button */
    color: white;
    border: none;
    padding: 13px 40px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 29px;
    cursor: pointer;
    margin-top: 1rem;
    transition: background-color 0.3s;

    &:hover {
        background-color: #140d54;
    }
`;

const FAQText = styled.p`
    margin-top: 2rem;
    font-size: 22px;
    font-family: Montserrat, sans-serif;
    color: #1b1464;
    text-align: center;
    padding: 0 20%;
    margin: 2rem auto;
`;

const StyledLink = styled(Link)`
    color: #1b1464;
    font-weight: bold;
    text-decoration: underline;
    &:hover {
        color: #0055a5;
        text-decoration: underline;
    }
`;

const EmailLink = styled.a`
    color: #1b1464;
    text-decoration: none;
    &:hover {
        color: #0055a5;
    }
`;

const Underline = styled.div`
    width: 250px;
    height: 1px;
    background-color: black;
    margin: 30px auto;
`;

const Subtitle = styled.h2`
    color: #1b1464;
    font-weight: 700;
    font-size: 37px;
    font-family: Montserrat, sans-serif;
    line-height: 48.76px;
    margin-top: 10px;
`;

const ContactText = styled.p`
    font-size: 20px;
    font-family: Montserrat, sans-serif;
    color: #1b1464;
    font-weight: 400;
    margin-top: 1rem;
    padding: 0 20%;
`;

const ContactLink = styled.a`
    color: #1b1464;
    text-decoration: none;
    &:hover {
        color: #0055a5;
    }
`;

function getClaimUrl() {
    const { hostname } = window.location;

    if (hostname === 'localhost' || hostname === 'hcr.dev.bpimsapps.com') {
        return 'https://hcc.dev.bpimsapps.com';
    } else if (hostname === 'hcr.uat.bpimsapps.com') {
        return 'https://hcc.uat.bpimsapps.com';
    } else if (hostname === 'homeprotectionrenewal.bpims.com') {
        return 'https://homeprotectionclaims.bpims.com';
    } else {
        return '#'; // Fallback or default URL if needed
    }
}

export default function Claim() {
    const claimUrl = getClaimUrl();

    return (
        <ClaimContainer fluid>
            <Row>
                <Col>
                    <h2 style={{ fontSize: '33px', color: '#1B1464', fontWeight: 'bold', marginBottom: '1rem' }}>
                        File a Claim
                    </h2>
                    <a href={claimUrl} target='_blank' rel='noopener noreferrer'>
                        <ClaimButton>GO TO CLAIMS PORTAL</ClaimButton>
                    </a>
                </Col>
            </Row>
        </ClaimContainer>
    );
}
